Directives.ChatBubbleDirective = function ChatBubbleDirective() {

    // @ngInject
    function ChatBubbleDirectiveControllerFunc($timeout, $scope, $injector, $element, AnalyticsService, UIUtils) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ChatBubbleDirectiveController';
        this.AnalyticsService = AnalyticsService;
        this.$element = $element;
        this.$timeout = $timeout;
        this.UIUtils = UIUtils;
    }

    var ChatBubbleDirectiveController = Class(Controllers.BaseController, {
        constructor: ChatBubbleDirectiveControllerFunc,

        isSystemMessage: function isSystemMessage() {
            return this.message.data && this.message.data.is_system_message;
        },

        addSystemMessage: function addSystemMessage() {
            var messageElement = this.$element.find(".message");
            var contentElement = this.UIUtils.sanitize(this.message.text)
            messageElement.append(contentElement);

            // add analytics to calendly link
            var linkElement = messageElement.find("#calendlyl-link");
            linkElement.on('click', function() {
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.ae_calendly_link);
            }.bind(this));
        }

    });

    function link(scope, element, attrs, controllers) {
        var simpleChatCtrl = controllers[0],
            chatBubbleCtrl = controllers[1];

        chatBubbleCtrl.options = simpleChatCtrl.options;
        chatBubbleCtrl.localUser = simpleChatCtrl.localUser;
    }

    return {
        bindToController: true,
        controller: ChatBubbleDirectiveController,
        controllerAs: 'cb',
        link: link,
        restrict: 'AE',
        require: ['^simpleChat', 'chatBubble'],
        templateUrl: 'angular/app/modules/core/features/chat/chat-bubble/chat_bubble_directive_template.html',
        scope: {
            message: '=',
            otherUser: '=',
            isLiveChat: '='
        }
    };
};
